module.exports = __webpack_public_path__ + "static/img/分类图片3@2x.1b99902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/分类/分类图片3@2x.png
// module id = OCgx
// module chunks = 192